export var skin = {
	base: Server.BASE_COLORS,
	hiLink: Server.HI_COLORS
};

skin.c = function(idx) {
	return this.base[idx];
};

skin.h = function(idx) {
	return this.hiLink[idx];
};

skin._c = function(idxOrColor) {
	const c = typeof idxOrColor === 'number' ? this.base[idxOrColor] : idxOrColor.toString();
	if (c.startsWith('#')) return c.substring(1);
	else return c;
};

skin._h = function(idxOrColor) {
	var h = typeof idxOrColor === 'number' ? this.hiLink[idxOrColor] : idxOrColor.toString();
	if (h.startsWith('#')) return h.substring(1);
	else return h;
};

skin.i = function(url, color, holor) {
	if (color == null) {
		if (holor == null) return url;
		var res = url;
		if (url.indexOf('?') > 0) res = res + '&';
		else res = res + '?';
		res = res + 'c=' + this._h(holor);
		return res;
	} else {
		var res = url;
		if (url.indexOf('?') > 0) res = res + '&';
		else res = res + '?';
		res = res + 'c=' + this._c(color);
		if (holor != null) {
			res = res + '&h=' + this._h(holor);
		}
		return res;
	}
};

const COLOR_PARAM = /c=[0-9a-f]{6}/i;
/**
 * Set color of the icon based on --fg variable from the container
 * @param {jQuery} img
 * @param {jQuery} [container]
 */
skin.icon = function(img, container) {
	let elm;
	if (container) elm = container.get(0);
	else elm = img.get(0);

	let color = getComputedStyle(elm).getPropertyValue('--fg').trim();
	if (color.startsWith("#")) color = color.substring(1);

	let newCol = "c="+color;
	let src = img.attr("src");
	if (COLOR_PARAM.test(src)) {
		// already has c= param
		img.attr("src", src.replace(COLOR_PARAM, newCol));
	} else {
		// no c= param yet
		if (src.indexOf("?") > 0) src = src + "&";
		else src = src + "?";
		img.attr("src", src + newCol);
	}
};

/**
 * @param {string} iconName
 * @param {?jQuery} container
 */
skin.iconTag = function (iconName, container) {
	if (iconName.indexOf(".jsp") > 0) {
		// SVG icon
		const img = $("<img src='"+iconName+"' class='icn'>");
		if (container) skin.icon(img, container);
		return img;
	} else {
		// Font icon
		return $(Icon.fi(iconName));
	}
};

/**
 * @param {string} iconName
 */
skin.iconHtml = function (iconName) {
	if (iconName.indexOf(".jsp") > 0) {
		// SVG icon
		return "<img src='"+iconName+"' class='icn'>";
	} else {
		// Font icon
		return Icon.fi(iconName);
	}
};

/**
 * Add color parameter to icon url
 * @param {string} icon - url to icon
 * @param {string} variable - CSS variable with required color
 */
skin.iconByVar = function(icon, variable) {
	if (icon.indexOf(".jsp") < 0) return icon;	// only for SVG/JSP icons
	let color = getComputedStyle(document.body).getPropertyValue(variable).trim();
	if (typeof color !== "string") return icon;
	if (color.startsWith("#")) color = color.substring(1);

	let newCol = "c="+color;
	if (COLOR_PARAM.test(icon)) {
		return icon.replace(COLOR_PARAM, newCol);
	} else {
		// no c= param yet
		if (icon.indexOf("?") > 0) icon = icon + "&";
		else icon = icon + "?";
		return icon + newCol;
	}
}

skin.semaphore = {
	red : Server.SEMAPHORE_RED,
	orange : Server.SEMAPHORE_ORANGE,
	green : Server.SEMAPHORE_GREEN
};
